import { render, staticRenderFns } from "./TipoAditivoForm.vue?vue&type=template&id=82c43612"
import script from "./TipoAditivoForm.vue?vue&type=script&lang=js"
export * from "./TipoAditivoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports